module.exports = __webpack_public_path__ + "static/1_1_defineai_NL-51c0dace3c56cecf4a3c15acc009dea1.svg";